import { render, staticRenderFns } from "./ErrorCreate.vue?vue&type=template&id=220e5f57&scoped=true&"
import script from "./ErrorCreate.vue?vue&type=script&lang=js&"
export * from "./ErrorCreate.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCreate.vue?vue&type=style&index=0&id=220e5f57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e5f57",
  null
  
)

export default component.exports